import apiService from '../util/request.js';
import SMP_CONFIG from '../util/smp_config';

/** module that deals with api communication functions for service case
 * @module caseApiService */

/** fetch terms of service / agreements by context key
 * @returns {AxiosPromise<any>}
 */
const getAgreements = () => {
  let params = {
    context: SMP_CONFIG.contextConfig.key,
    max: 100,
    offset: 0
  };
  return apiService.get('/smp/api/agreements', { params });
}

/** fetch service case by key
 * @returns {AxiosPromise<any>}
 */
const getCase = (key) => {
  return apiService.get(`/service-case/case/${key}`);
};

/** fetch service case by offer key
 * @returns {AxiosPromise<any>}
 */
const getCaseByBookedOfferKey = (key) => {
  return apiService.get(`/service-case/case/booking/${key}`);
};

/** fetch service case by message token
 * @returns {AxiosPromise<any>}
 */
const getCaseByToken = (key) => {
  return apiService.get(`/service-case/case/message/${key}`);
};

export default {
  getAgreements,
  getCase,
  getCaseByBookedOfferKey,
  getCaseByToken
}
